import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import { IInterventionsGet } from '@Arti-zen/package-backoffice'
import { RootState } from 'store/store'
import { ApiArtizenBO } from 'utils/artizenConnector'
import { IInterventionListState, InterventionListStoreErrorType } from './store.interventionList.interfaces'

const fetch = {
  action: createAsyncThunk('interventions/get', async (filters: IInterventionsGet | 'refresh', thunkApi) => {
    const state = thunkApi.getState() as RootState
    const newFilters = filters === 'refresh' ? { ...state.interventionList.filters, page: 1 } : filters
    return ApiArtizenBO.interventions.get(newFilters)
  }),
  reducer: (builder: ActionReducerMapBuilder<IInterventionListState>) => {
    builder
      .addCase(fetch.action.pending, (state, action) => {
        state.filters = action.meta.arg === 'refresh' ? { ...state.filters, page: 1 } : action.meta.arg
        state.errorType = null
        state.isLoading = true
      })
      .addCase(fetch.action.fulfilled, (state, action) => {
        state.isQueriedAllCompleted = action.payload.length < state.filters.limit
        state.interventions = action.payload
        state.isLoading = false
      })
      .addCase(fetch.action.rejected, (state, _action) => {
        state.interventions = []
        state.isLoading = false
        state.errorType = InterventionListStoreErrorType.network
      })
  },
}

const fetchNextPage = {
  action: createAsyncThunk('interventions/getNextPage', async (_, thunkApi) => {
    const state = thunkApi.getState() as RootState
    const { filters } = state.interventionList
    return ApiArtizenBO.interventions.get({ ...filters, page: filters.page })
  }),
  reducer: (builder: ActionReducerMapBuilder<IInterventionListState>) => {
    builder
      .addCase(fetchNextPage.action.pending, (state, _action) => {
        state.errorType = null
        state.filters.page += 1
        state.isLoading = true
      })
      .addCase(fetchNextPage.action.fulfilled, (state, action) => {
        state.isQueriedAllCompleted = action.payload.length < state.filters.limit
        state.interventions = [...state.interventions, ...action.payload]
        state.isLoading = false
      })
      .addCase(fetchNextPage.action.rejected, (state, _action) => {
        state.isLoading = false
        state.errorType = InterventionListStoreErrorType.network
      })
  },
}

export const asyncActions = {
  fetch: fetch.action,
  fetchNextPage: fetchNextPage.action,
}

export const extraReducers = (builder: ActionReducerMapBuilder<IInterventionListState>) => {
  fetch.reducer(builder)
  fetchNextPage.reducer(builder)
}
